import styled from '@emotion/styled'

import { palette, spacing } from '../constants'
import { Strong } from '../typography'

export const Container = styled.div`
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  text-decoration: none;
`

export const Month = styled(Strong)`
  background-color: ${palette.rose2};
  border-radius: 3px 3px 0 0;
  color: ${palette.white};
  font-size: 12px;
  line-height: 15px;
  padding: 0 ${spacing.minorScale(1)}px;
  text-align: center;
  text-transform: uppercase;
`

export const Day = styled(Strong)`
  background-color: ${palette.lightGray};
  border-radius: 0 0 3px 3px;
  color: ${palette.almostBlack};
  font-size: 13px;
  line-height: 18px;
  padding: 0 ${spacing.minorScale(1)}px;
  text-align: center;
`
